import { Link } from "react-router-dom";
import { Facebook, Instagram, Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import { CATEGORIES } from "@/lib/api";
import { LEGAL_LINKS } from "@/pages/Legal";

const XIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}><path d="M18.9 2H22l-7.6 8.7L23 22h-6.8l-5.3-6.9L4.8 22H1.7l8.1-9.3L1 2h7l4.8 6.3L18.9 2Zm-1.2 18h1.7L6.4 3.9H4.6L17.7 20Z" /></svg>
);

const SOCIAL = [
  { icon: Instagram, href: "https://www.instagram.com/sobrinosport", label: "Instagram" },
  { icon: Facebook, href: "https://www.facebook.com/p/Sobrino-Sport-100063668194341/", label: "Facebook" },
  { icon: XIcon, href: "https://x.com/sobrinosport", label: "X" },
];

export const Footer = () => (
  <footer className="bg-brand-dark text-white pt-16 pb-24 sm:pb-8 px-6 lg:px-12 mt-24" data-testid="site-footer">
    <div className="mx-auto max-w-7xl grid gap-12 md:grid-cols-12">
      <div className="md:col-span-4">
        <img src="/logo-light.png" alt="Sobrino Sport" className="h-28 w-auto" data-testid="footer-logo" />
        <p className="mt-5 text-white/70 max-w-xs text-sm leading-relaxed">Ropa, calzado y accesorios deportivos en Olula del Río (Almería) y ahora también online.</p>
        <div className="mt-6 flex gap-3">
          {SOCIAL.map(({ icon: I, href, label }) => (
            <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label} data-testid={`footer-social-${label.toLowerCase()}`}
              className="w-10 h-10 rounded-full bg-white/10 grid place-items-center hover:bg-verde transition-colors">
              <I className="w-4 h-4" />
            </a>
          ))}
        </div>
        <p className="mt-3 text-xs text-white/60">Síguenos en @sobrinosport</p>
      </div>
      <div className="md:col-span-2">
        <p className="eyebrow eyebrow-light">Tienda</p>
        <ul className="mt-4 space-y-2 text-sm text-white/80">
          {CATEGORIES.map((c) => (
            <li key={c.id}><Link to={`/tienda?category=${c.id}`} className="hover:text-white" data-testid={`footer-${c.id}`}>{c.label}</Link></li>
          ))}
          <li><Link to="/outlet" className="font-semibold text-verde-light hover:text-white" data-testid="footer-outlet">Outlet</Link></li>
        </ul>
      </div>
      <div className="md:col-span-3">
        <p className="eyebrow eyebrow-light">Visítanos</p>
        <ul className="mt-4 space-y-3 text-sm text-white/80" data-testid="footer-contact">
          <li className="flex gap-3"><MapPin className="w-4 h-4 mt-0.5 shrink-0 text-verde-light" /><a href="https://maps.google.com/?q=C%2F+Granada+4+Olula+del+R%C3%ADo+Almer%C3%ADa" target="_blank" rel="noreferrer" className="hover:text-white">C/ Granada, nº 4 - Local 3<br />04860 Olula del Río (Almería)</a></li>
          <li className="flex gap-3"><Phone className="w-4 h-4 mt-0.5 shrink-0 text-verde-light" /><span><a href="tel:+34661666916" className="hover:text-white" data-testid="footer-phone">661 666 916</a> · <a href="tel:+34950443465" className="hover:text-white" data-testid="footer-phone-2">950 44 34 65</a></span></li>
          <li className="flex gap-3"><MessageCircle className="w-4 h-4 mt-0.5 shrink-0 text-verde-light" /><a href="https://wa.me/34661666916" target="_blank" rel="noreferrer" className="hover:text-white" data-testid="footer-whatsapp">WhatsApp</a></li>
          <li className="flex gap-3"><Mail className="w-4 h-4 mt-0.5 shrink-0 text-verde-light" /><a href="mailto:sobrinosport@gmail.com" className="hover:text-white" data-testid="footer-email">sobrinosport@gmail.com</a></li>
        </ul>
      </div>
      <div className="md:col-span-3">
        <p className="eyebrow eyebrow-light">Compra segura</p>
        <p className="mt-4 text-sm text-white/80 leading-relaxed">Pago con Bizum o transferencia · Envío 24/48 h en península · Cambios y devoluciones en 15 días.</p>
        <Link to="/devoluciones" className="mt-3 inline-block text-sm font-semibold text-verde-light hover:text-white" data-testid="footer-returns">Política de devoluciones →</Link>
      </div>
    </div>
    <div className="mx-auto max-w-7xl mt-14 pt-6 border-t border-white/10 flex flex-wrap justify-between gap-2 text-xs text-white/50 font-mono">
      <p>© {new Date().getFullYear()} Sobrino Sport · Jorge Sobrino Hernández · NIF 75227763F</p>
      <nav className="flex flex-wrap gap-4" data-testid="footer-legal">
        {LEGAL_LINKS.map(([id, label]) => (
          <Link key={id} to={id === "devoluciones" ? "/devoluciones" : `/legal/${id}`} className="hover:text-white" data-testid={`footer-legal-${id}`}>{label}</Link>
        ))}
      </nav>
      <p>C/ Granada, 4 - Local 3 · 04860 Olula del Río (Almería) · Diseño: <a href="https://aimarca.es/" target="_blank" rel="noreferrer" className="hover:text-white underline" data-testid="footer-aimarca">AIMARCA</a></p>
    </div>
  </footer>
);
